import React from "react";
import {
  ImageWrapperFigure,
  ImageWrapperImage,
} from "@components/item/ItemStyling";
import { SUMMER_AWS_BUCKET_URL } from "@components/events/inspire-your-summer/InspireYourSummer";
import { useMediaQuery } from "react-responsive";

const SummerBannerImage = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <ImageWrapperFigure ratio={isMobile ? "3/2" : "2.5/1"}>
      <ImageWrapperImage
        src={`${SUMMER_AWS_BUCKET_URL}/${isMobile ? "banner_mobile" : "banner_web"}.jpg`}
        alt="INSPIRE Your Summer"
      />
    </ImageWrapperFigure>
  );
};

export default SummerBannerImage;
